import { defineComponent as _defineComponent } from 'vue'
import { to, userEnv } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { QrpayFromScene, jumpScanpay } from '@tencent/wphk-components-jump-page';
import { onBeforeMount, computed } from 'vue';
import { setUpWeixinInit } from '@/utils/cache-setup-wx';
import { QrcodeIcon } from '@tencent/wphk-icon-vue';

// 判断是否支持原生刷卡
// 由于h5侧不支持不带优惠直接拉起刷卡，所以对于不支持原生刷卡的终端微信，不展示拉起付款码按钮

export default /*#__PURE__*/_defineComponent({
  __name: 'qrpay',
  setup(__props) {

const isSupportNative = computed(() => userEnv.isAllWxVersionSupported({ android: '8.0.21', iphone: '8.0.20' }));

/** 拉起原生付款码 */
async function handleQrpay() {
  const [err] = await to(jumpScanpay('', 'merchant-channel', { scene: QrpayFromScene.HKLife }));
  if (err) {
    showBusinessError(err);
    throw new CustomException(err, 'jumpScanpayByCVIdErr', 'jump scanpay error');
  }
}

onBeforeMount(() => {
  to(setUpWeixinInit());
});


return { __sfc: true,isSupportNative, handleQrpay, QrcodeIcon }
}

})